import { postRequest } from "../../utils/apiHelper";

export const authService = {
    login,
    logout,
    getProfileData,
    getUpdatedStatus,
    getLoginForDevice,
};

async function login(params) {
    const response = await postRequest("auth/login", params);
    return response;
}

async function logout(data) {
    const response = await postRequest("auth/logout", data);
    return response;
}

async function getProfileData(params) {
    const response = await postRequest("auth/profile", params);
    return response;
}

async function getUpdatedStatus(params) {
    const response = await postRequest("auth/getUpdatedStatus", params);
    return response;
}

async function getLoginForDevice(params) {
    const response = await postRequest("auth/getLoginForDevice", params)
    return response
}
